module.exports = "https://trybtryb-legacy.web.app/img/account.1fccff74.svg";